export const improvementChoices = [
  'Heating & Cooling',
  'Solar',
  'Roofing',
  'Windows & Doors',
  'Other',
];

export const timeFrames = ['Now', 'Weeks', 'Months'];

export const i18nImprovements = [
  { value: 'Heating & Cooling', display: 'improvements.heatingAndCooling' },
  { value: 'Solar', display: 'improvements.solar' },
  { value: 'Roofing', display: 'improvements.roofing' },
  { value: 'Windows & Doors', display: 'improvements.windowsAndDoors' },
  { value: 'Other', display: 'improvements.other' },
];

export const i18nTimeFrames = [
  { value: 'Now', display: 'timeFrames.now' },
  { value: 'Weeks', display: 'timeFrames.weeks' },
  { value: 'Months', display: 'timeFrames.months' },
  { value: 'WorkStarted', display: 'timeFrames.workStarted' },
  {
    value: 'RefinanceCompletedWork',
    display: 'timeFrames.refinanceCompletedWork',
  },
];
